import React, { useState, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { TfiDownload } from "react-icons/tfi";
import { MdError } from "react-icons/md";
import {
  ISO_Weld_log_Form_Non_Welded_Table_Header,
  ImageBaseUrl,
  errorMessages,
} from "../../../utils/helperData";

const NonWeldedInspectionTable = ({ inspectionDetaildata }) => {
  const [hoveredErrorInfo, setHoveredErrorInfo] = useState(null);

  const inspectionDetails = useMemo(
    () => inspectionDetaildata?.non_weld_material || [],
    [inspectionDetaildata]
  );

  const handleDownload = (documents) => {
    if (!documents || documents?.length === 0) {
      alert("No documents available to download.");
      return;
    }
    documents.forEach((doc) => {
      const link = document.createElement("a");
      link.href = `${ImageBaseUrl}${doc}`;
      link.download = doc;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const isFieldInvalid = (detail, fieldKey) => {
    return detail[fieldKey] === false;
  };

  const renderValidatedCell = (detail, value, fieldKey, rowIndex) => {
    const isInvalid = isFieldInvalid(detail, fieldKey);

    return (
      <TableCell
        sx={{
          fontSize: "16px",
          color: isInvalid ? "red" : "#626262",
          position: "relative",
          padding: "16px",
        }}
      >
        {value || "-"}
        {isInvalid && (
          <MdError
            className="text-red-500 absolute top-3 right-1 transform -translate-y-1/2 cursor-pointer"
            onMouseEnter={() => setHoveredErrorInfo({ rowIndex, fieldKey })}
            onMouseLeave={() => setHoveredErrorInfo(null)}
          />
        )}
        {hoveredErrorInfo &&
          hoveredErrorInfo.rowIndex === rowIndex &&
          hoveredErrorInfo.fieldKey === fieldKey && (
            <div
              className="absolute z-10 bg-red-100 text-red-800 p-2 rounded-md shadow-lg text-xs"
              style={{
                top: "100%",
                left: 0,
                width: "max-content",
                maxWidth: "200px",
              }}
            >
              {errorMessages[fieldKey]}
            </div>
          )}
      </TableCell>
    );
  };

  return (
    <div className="flex justify-center overflow-auto">
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "auto",
          border: "1px solid #ccc",
          borderRadius: "10px",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {ISO_Weld_log_Form_Non_Welded_Table_Header.map(
                (header, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "rgb(75 85 99)",
                      backgroundColor: "rgb(243 244 246)",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {header}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {inspectionDetails.map((detail, index) => (
              <TableRow
                hover
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                {renderValidatedCell(
                  detail,
                  detail.weld_size,
                  "is_valid_size",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.description,
                  "is_valid_description",
                  index
                )}
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.doc_id1?.name || "-"}
                </TableCell>
                {renderValidatedCell(
                  detail,
                  detail?.heat_no1,
                  "is_valid_heat1",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.serial_no1,
                  "is_valid_serial1",
                  index
                )}
                {detail?.document?.length > 0 && (
                  <TableCell sx={{ fontSize: "16px" }}>
                    <TfiDownload
                      className="h-7 w-7 cursor-pointer"
                      onClick={() => handleDownload(detail?.document)}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default NonWeldedInspectionTable;
